// utils
import React from "react";
import { useMatch } from "react-router-dom";

// custom utils
import { getCurrentLanguage, LANGUAGES } from "../../../utils/langUtils";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";


/**
 * SubmitConsentGdpr section
 * @returns HTML code translated "By submitting, you agree to the processing of personal data."
 */
export default function SubmitConsentGdpr() {

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";
    let translation = translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    // solves broken layout of some pages in build
    const [hasMounted, setHasMounted] = React.useState(false);
    React.useEffect(() => {
        setHasMounted(true);
    }, []);
    if (!hasMounted) {
        return null;
    }

    return (
        <>
            <div className="paragraph-extra-small">
                {translation.consent.part1}<a className="link-href" href={process.env.PUBLIC_URL + '/pdf/' + translation.gdpr} target="_blank"  rel="noreferrer">{translation.consent.part2}</a>{translation.consent.part3}
            </div>
        </>
    );
}
